module.exports = __webpack_public_path__ + "static/media/5ed7b1b372f4e5e57a748797.aa0551dc.png";